import React from 'react';
import styles from './FormField.module.css';

function FormFieldInformationalText({ label }: { label?: string }) {
    return (
        <div className={styles.informationalText}>
            {label?.split('\n').map((text, idx) => (
                <div key={idx} className={styles.informationalTextLine}>{text}</div>
            ))}
        </div>
    );
}

export default React.memo(FormFieldInformationalText);
